export function dateString(date: string) {
  const formatter = Intl.DateTimeFormat('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
  return formatter.format(new Date(date));
}
